import moment from 'moment'
export default {
  format(value) {
    return value
      .toString()
      .replace(/\D/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  format2(value) {
    return value
      .replace(/,/g, '')
      .match(/^-?\d+(?:\.\d{0,2})?/)[0]
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  format3(value) {
    const fixValue = value + ''
    return parseFloat(fixValue.replace(/,/g, ''))
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  formatPeriode(value) {
    if (value == '') return value
    return parseFloat(value.replace(/,/g, ''))
      .toFixed(1)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  convertResult(value, currency) {
    const split = value.split('.')
    let merged = null
    if (split[1] == '00') {
      merged = split[0]
    } else {
      if (currency == 'IDR') {
        // Round Up & Round Down
        let idrConverted = Number(split[0])
        const commaSplit = split[1].split('')
        if (commaSplit[0] < 5) {
          idrConverted += 0
          merged = String(idrConverted)
        } else {
          idrConverted += 1
          merged = String(idrConverted)
        }
      } else {
        merged = split.join('.')
      }
    }
    if (split.length == 1 || split[1] == '00') {
      return this.format(merged)
    } else {
      if (currency == 'IDR') {
        return this.format(merged)
      } else {
        return this.format2(merged)
      }
    }
  },
  fixedFormat({ e, isDecimal, val }, currency) {
    const targetValue = val
    let result = null
    if (targetValue == '' || targetValue[0] == 0) {
      isDecimal = false
      result = ''
    } else {
      if (e.key == '.' && targetValue != '.') {
        if (currency == 'IDR') {
          result = this.format(targetValue)
        } else {
          const changeVal = `${targetValue}00`
          result = this.format2(changeVal)
          isDecimal = true
        }
      } else {
        if (!isDecimal || !targetValue.includes('.')) {
          result = this.format(targetValue)
        } else {
          result = this.format2(targetValue)
        }
      }
    }
    const obj = {
      result,
      isDecimal
    }
    return obj
  },
  currencyFormat(val, isCanDecimal = false) {
    if (val == null || val == '') return val
    if ((val[0] == 0 || val[0] == '0') && !isCanDecimal) return ''
    if (isCanDecimal) {
      const splitVal = val.toString().split('.')
      if (splitVal.length == 1) {
        return this.format(val)
      } else {
        return this.format2(splitVal.join('.'))
      }
    } else {
      return this.format(val)
    }
  },
  getPreviousDate(val) {
    const today = new Date()
    const getDate = today.getDate()
    const getMonth = today.getMonth() + 1 - val
    const getYear = today.getFullYear()
    let resultMonth = null
    let resultYear = null
    if (getMonth < 1) {
      resultMonth = 12 + getMonth
      resultYear = getYear - 1
    } else {
      resultMonth = getMonth
      resultYear = getYear
    }
    while (resultMonth < 1) {
      resultMonth = 12 + resultMonth
      resultYear = resultYear - 1
    }
    return `${resultYear}-${resultMonth}-${getDate}`
  },
  validateWithMergedCost(costEstimation, isTouched) {
    let returnValue
    if (isTouched) {
      const biaya = costEstimation.split(',')
      const merged = biaya.join('')
      const isMoreThanZero = merged > 0.0
      if (costEstimation != '' && costEstimation != null && isMoreThanZero) {
        returnValue = false
      } else {
        returnValue = true
      }
      return returnValue
    }
  },
  validateDateCrf(apiDate, date) {
    let returnValue = ''
    const dateObj = new Date()
    const month = dateObj.getUTCMonth()
    const day = dateObj.getUTCDate()
    const year = dateObj.getUTCFullYear()
    const newdate = new Date(year, month, day)
    if (
      apiDate.firstDate != '' &&
      apiDate.firstDate != null &&
      apiDate.firstDate != undefined
    ) {
      const FirstDateArr = moment(apiDate.firstDate)
        .format('YYYY-MM-DD')
        .split('-')
      const FirstDateApi = new Date(
        FirstDateArr[0],
        FirstDateArr[1] - 1,
        FirstDateArr[2]
      )
      const secondDateArr = moment(apiDate.secondDate)
        .format('YYYY-MM-DD')
        .split('-')
      const secondDateApi = new Date(
        secondDateArr[0],
        secondDateArr[1] - 1,
        secondDateArr[2]
      )
      if (FirstDateApi < newdate) {
        const fromSeconDateToToday = date < newdate && date > secondDateApi
        const belowFirstDate = date < FirstDateApi
        const afterFirstDateToSecondDate =
          date > FirstDateApi && date < secondDateApi
        const firstDateToToday = date > FirstDateApi && date < newdate
        if (secondDateApi >= newdate) {
          returnValue =
            fromSeconDateToToday || belowFirstDate || firstDateToToday
        } else {
          returnValue =
            fromSeconDateToToday || belowFirstDate || afterFirstDateToSecondDate
        }
      } else {
        returnValue = date < newdate
      }
    } else {
      returnValue = date < newdate
    }

    return returnValue
  },
  periodeBulan(startDate, endDate) {
    const STARTDATE = startDate
    const ENDDATE = endDate
    const monthDiff =
      (ENDDATE.getFullYear() - STARTDATE.getFullYear()) * 12 +
      (ENDDATE.getMonth() - STARTDATE.getMonth())
    const daysInStartMonth = new Date(
      STARTDATE.getFullYear(),
      STARTDATE.getMonth() + 1,
      0
    ).getDate()
    const daysInEndMonth = new Date(
      ENDDATE.getFullYear(),
      ENDDATE.getMonth() + 1,
      0
    ).getDate()
    const partialStartMonth =
      (daysInStartMonth - STARTDATE.getDate() + 1) / daysInStartMonth
    const partialEndMonth = ENDDATE.getDate() / daysInEndMonth
    const result = monthDiff - 1 + partialStartMonth + partialEndMonth
    const splitResult = result.toFixed(1).split('.')
    let finalResult
    if (splitResult[0] == 0 && splitResult[1] == 0) {
      finalResult = ''
    } else if (splitResult[1] == 0) {
      finalResult = splitResult[0]
    } else {
      finalResult = result.toFixed(1)
    }
    return this.formatPeriode(finalResult)
  },
  limitBiaya(val, currency) {
    const targetVal = val.target.value
    const maxBase = 18
    const maxLimit = currency == 'USD' ? maxBase - 2 : maxBase
    const splitUsd = currency == 'USD' ? targetVal.split('.') : null
    const splitComma =
      currency == 'USD' ? splitUsd[0].split(',') : targetVal.split(',')
    const checkLength = splitComma.join('')
    if (checkLength.length > maxLimit) {
      let result = ''
      const splitNum = checkLength.split('')
      for (let i = 0; i < maxLimit; i++) {
        result = result + splitNum[i]
      }
      if (currency == 'USD') {
        if (splitUsd.length == 2) {
          return `${result}.${splitUsd[1]}`
        } else {
          return result
        }
      } else {
        return result
      }
    } else {
      return targetVal
    }
  },
  limitQuantityExtention(val, isQuantity) {
    const maxBase = isQuantity ? 10 : 5
    const stringVal = val.split(',')
    const joinVal = stringVal.join('')
    const checkLength = joinVal.length
    if (checkLength > maxBase) {
      return joinVal.slice(0, -1)
    } else {
      return stringVal
    }
  },
  checkSemicolon(value) {
    let fixedVal
    const arr = value.split('')
    arr.forEach((element, index) => {
      if (element == ';') {
        arr.splice(index, 1)
      }
    })
    fixedVal = arr.join('')
    return fixedVal
  }
}
